<template>
  <section class="f-72">
    <div class="qmusic f-select-center">
      <div class="title f-center-title">QQ 音乐重磅升级，更合你心意</div>
      <!-- 第一行图片 -->
      <div class="top-section" v-ia>
        <img
          class="image-wrapper"
          src="@/v2/auto/assets/image/72/1.jpg"
          alt="QQ音乐升级"
        />
      </div>
      <!-- 第二行图片 -->
      <div class="bottom-section" v-ia>
        <img
          class="image-wrapper left-wrapper"
          src="@/v2/auto/assets/image/72/2.jpg"
          alt="快速推荐"
        />
        <img
          class="image-wrapper right-wrapper"
          src="@/v2/auto/assets/image/72/3.svg"
          alt="Hi-Res"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'qmusic',
  components: {},
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {},
  methods: {
    switchImage(index) {
      this.activeIndex = index
    },
  },
}
</script>

<style lang="less" scoped>
.f-72 {
  width: 100%;
  background: linear-gradient(180deg, #f3f4fb 0%, #fff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  // Common styles
  .title {
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
    background: radial-gradient(
      146.28% 782.22% at 12.95% -74.31%,
      #0061d8 0%,
      #00d369 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  // Image wrapper common styles
  .image-wrapper {
    border-radius: 30px;
    position: relative;
    overflow: hidden;
    color: #000;
    width: 100%;
    height: 100%;
  }

  .left-wrapper {
    width: 57.5%;
  }

  .right-wrapper {
    width: 40.5%;
  }

  // QQ Music section
  .qmusic {
    height: auto;
    margin-top: 100px;
    margin-bottom: 200px;

    .top-section {
      margin-bottom: 24px;
      display: flex;
      justify-content: center;
    }

    .bottom-section {
      display: flex;
      justify-content: center;
      gap: 24px;
    }
  }
}
</style>
